module.exports = {"appname":"Apps Script DB","editor":"Editor","load":"Load","add":"Add","update":"Update","delete":"Delete","dburl":"Database Url","copy":{"success":"Copied!","failed":"Copy failed! Please copy the following url."},"key":{"add":"Key:","duplicate":"Key \"{key}\" already exists."}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = 12
// module chunks = 1